import {Fancybox} from "@fancyapps/ui";
import {Spinner} from "../libs/spinner";

import {requestGallery} from "../libs/apiv2-requests";

export default context => {

    let imagesToDelete = [], isNewGallery = false, style;

    const loadGallery = async function (id) {
        const loadDefault = async function() {
            isNewGallery = true
            try {
                return await $.get(`/site/options/get-default-gallery/${cid}`)
            } catch {
                return {}
            }
        }
        let data = {}
        try {
            if (!id) {
                return await loadDefault()
            }
            data = requestGallery(id)
        } catch {
            data = await loadDefault()
        }
        return data;
    }

    const addImagePreview = (info, url) => {
        const placeholder = window.translate.input_gallery_credit_placeholder || '';
        const value = info.credit || '';
        let el = $(`<div class="gallery-item">`
            + `<img src="${url}" alt="">`
            + `<div class="form-group"><input type="text" class="form-control" name="credit" value="${value}" placeholder="${placeholder}"></div>`
            + `<a href="#" class="delete-button"><span class="glyphicon glyphicon-trash" title="trash"></span></a>`
            + `</div>`);
        el.data('image', info);
        $("#gallery-wrap").append(el);
        return el;
    }

    $('[data-role="edit-gallery"]', context).each(function() {
        const $this = $(this);
        const spinner = new Spinner("#gallery-wrap");
        spinner.show();
        loadGallery($this.data('groupid') || 0).then(data => {
            style = data.galleryStyleType || 'grid';
            if (data.images) {
                data.images.forEach(item => {
                    addImagePreview(item, item.thumbnailUrl)
                });
            }
            $this
                .find('input[name="gallery-style"][value="' + style + '"]')
                .prop('checked', true);
            spinner.remove();
        })
        $this.find('input[type="file"]').on('input', function () {
            const maxCount = 20
            let totalCount = Math.min(maxCount - $this.find(".gallery-item").length, this.files.length)
            const renderFile = function(file) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function(e) {
                    if (e.total < 4 * 1024 * 1024) {
                        const elem = addImagePreview({
                            'state': 'new',
                            'name': file.name,
                        }, this.result)
                        elem.data('file', file);
                        elem.data('src', this.result);
                        elem.data('type', file.type);
                    } else {
                        // console.log('This file size is: ' + e.total / 1024 / 1024 + "MiB");
                        window.openAlert(window.translate.app_error_image_size || '', 'error');
                    }
                }

            }
            for (let index = 0; index < totalCount; index++) {
                renderFile(this.files[index])
            }
        });

        $this.on('click', 'a.delete-button', function (e) {
            e.preventDefault();
            const elem = $(this).closest(".gallery-item");
            let id = elem.data('image').id || 0;
            if (id) {
                imagesToDelete.push(id);
            }
            elem.remove();
        });

        $this.find('[name=gallery-style]').on('change', function (e) {
            style = $(this).val()
        });

        $this.closest('form').on('event.collect.gallery.data', function(e, data) {
            data.isNewGallery = isNewGallery;
            data.style = style;
            data.added = [];
            data.updated = {};
            data.deleted = imagesToDelete;
            $this.find('#gallery-wrap .gallery-item').each(function() {
                const el = $(this),
                      info = el.data('image');
                if (info.state === 'new') {
                    data.added.push({
                        file: el.data('src'),
                        type: el.data('type'),
                        name: info.name,
                        credit: el.find('input[name="credit"]').val()
                    });
                } else if (info.id) {
                    data.updated[info.id] = el.find('input[name="credit"]').val();
                }
            });
        });
    });

    Fancybox.bind('[data-role="edit-gallery"] .gallery a.gallery-item', {
        Toolbar: {
            display: [
                "close",
            ],
        },
    })

}
